import React from 'react'
import {BrowserRouter as Router} from 'react-router-dom'
import {useRoutes} from './routes'
import 'materialize-css'
import Footer from './components/Footer'
import Header from './components/Header'


function App() {
  const routes = useRoutes(true)
  return (
    <div>
    <Header />
    <div className="container z-depth-4" id="#main"><Router>{routes}</Router></div>
    <Footer />
    </div>
  )
}


  
export default App;
